import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { FlexBox, Orientation, SkeletonTypography, Typography } from '@lumapps/lumx/react';

import { useBlockVideoContext } from '../BlockVideoContext';
import { CLASSNAME as BLOCK_VIDEO_CLASSNAME } from '../constants';

import './index.scss';

export const CLASSNAME = `${BLOCK_VIDEO_CLASSNAME}-reactions` as const;

/**
 * Displays the reaction of a video
 */
export const Reactions = ({ children }: { children: React.ReactNode }) => {
    const { canDisplay, isLoading, theme } = useBlockVideoContext();
    const { block } = useClassnames(CLASSNAME);

    if (!children) {
        return null;
    }

    if (!canDisplay('REACTIONS')) {
        return null;
    }

    if (isLoading) {
        return (
            <SkeletonTypography className={block('skeleton')} theme={theme} typography={Typography.body1} width="10%" />
        );
    }

    return (
        <FlexBox orientation={Orientation.horizontal} gap="tiny">
            {children}
        </FlexBox>
    );
};
